import React from 'react';
import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

const TicketProvider = ({ logo, onClick }) => (
    <div className="col-lg-6 col-md-6 col-12">
        <div className="ticket-provider__content bg-white text-center border border-2 rounded p-4 active mb-5">
            <div className="ticket-provider__image p-5">
                <img src={logo} alt='Provider logo' />
            </div>
            <Button variant='outline-primary' onClick={onClick} className="mt-3">
                <FormattedMessage id='select_provider_iabilet' />
            </Button>
        </div>
    </div>
);

export default TicketProvider;
